export default "__VITE_ASSET__CqRkfYuE__"